import{a as o}from"./chunk.7JRQDNM6.js";var e=class extends o{};customElements.get("mc-radio-group")||customElements.define("mc-radio-group",e);export{e as a};
//# sourceMappingURL=chunk.E7ZV2U4F.js.map
